import React from 'react'
import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";



import swimmingpool from "../images/swimming pool.jpg";
import swimmingpool2 from "../images/swimming pool p.jpg";
import pool from "../images/swimming pool 3.jpg";
import swimmingpool4 from "../images/swimming pool 4.jpg";






import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'




import Header from "../inc/Header";

function Swimming() {
  return (
    <div>

      <Header />
      <br />
      <br />
      <br />
      <br />
      <ScrollToTop smooth top="100" color="maroon" />
      <div className='exteriordesign'>
        <div className="album py-1">
          <div className="container mt-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Swimming pool </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className='az2service'>
        <div className="album py-0">
          <div className="container">
            <div className="row">

              <div className="col-md-6">
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <div className="col-md-6 me-2 mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>

                          <img src={swimmingpool} className="card-img-top" alt="swimmingpool"/>

                        </Zoom>
                        <div className="card-body">
                          <h5 style={{ color: "black" }} className="card-title mb-2">Swimming Pool </h5>
                         

                          <div className="d-flex justify-content-between align-items-center mb-0">
                            <a className='buttona2zservice me-2'  style={{color:"white"}} href='tel: 9732000307'> Book Now</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6  mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={swimmingpool2} className="card-img-top" alt="swimmingpool"/>
                        </Zoom>
                        <div className="card-body">
                          <h5 style={{ color: "black" }} className="card-title mb-2">Swimming Pool</h5>
                        
                          <div className="d-flex justify-content-between align-items-center mb-0">
                            <a className='buttona2zservice me-2'  style={{color:"white"}} href='tel: 9732000307'> Book Now</a>

                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
              <div className="col-md-6">
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <div className="col-md-6 me-2 mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={pool} className="card-img-top" alt="swimmingpool"/>
                        </Zoom>
                        <div className="card-body">
                          <h5 className="card-title mb-2">Swimming Pool </h5>
               
                          <div className="d-flex justify-content-between align-items-center mb-0">
                            <a className='buttona2zservice me-2'  style={{color:"white"}} href='tel: 9732000307'> Book Now</a>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6  mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={swimmingpool4} className="card-img-top" alt="swimmingpool4"/>
                        </Zoom>
                        <div className="card-body">
                          <h5 className="card-title mb-2" >Swimming Pool                              </h5>
                      
                          <div className="d-flex justify-content-between align-items-center mb-0">
                            <a className='buttona2zservice me-2'  style={{color:"white"}} href='tel: 9732000307'> Book Now</a>

                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

    

  <br />

      <br />


      </div>
    
    </div>
  )
}

export default Swimming